import { render, staticRenderFns } from "./TopUpAmountItem.vue?vue&type=template&id=351f17d4&scoped=true&"
import script from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
export * from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAmountItem.vue?vue&type=style&index=0&id=351f17d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f17d4",
  null
  
)

export default component.exports